// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import Vuelidate from 'vuelidate'


import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import countrylist from './assets/countries.json'

Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(Vuelidate)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faDog,faCat,faCalendar} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCat,faDog,faCalendar)

Vue.component('faicon', FontAwesomeIcon)

Vue.config.productionTip = false



const store = new Vuex.Store({
  state: {
    lang: 'hu',
    _id: '',
    countries: countrylist,
    measurements: [],
    demos: []
  },
  mutations: {
    changeLang (state, lang) {
      state.lang = lang
    },
    setId (state,id){
      state._id = id
    },
    addMeasurement(state,measurement){
      state.measurements.push(measurement)
    },
    addDemo(state,demo){
      state.demos.push(demo)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  render: h => h(App)

})
